import React, { useState, Fragment, Component } from 'react'
import { accessRole } from '../../../../../helpers/access_role'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import PegawaiSideBar from '../../../GlobalComponents/PegawaiSidebar';
import moment from 'moment';
import { Preview } from '../../../../../helpers/ui/FileInput';

// const peg_name = JSON.parse(localStorage.getItem('userdata'))?.employee_name ?? "";

class IndexView extends Component {

    detailBloc = new DetailBloc()

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_name = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_full_name : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_full_name : "")
    employee_current_position_name = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_current_position_name : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_current_position_name : "")

    constructor(props) {
        super(props)
        this.state = {
            isLocal : 1

        }
    }

    titleCase = (s) => s.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase())

    dateParse = (input) =>{
        let res = "";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            document_skk: response.document_skk,
                            documents: response.documents,
                            isLocal: response.family_place_of_birth_national == "Luar Negeri" ? 0 : 1,
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="anak"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Detail Anak</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Anak
                                    </CardSubtitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama Anak
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_name !== "" ? this.state.detail.family_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nomor Induk Kependudukan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_identity_number !== "" ? this.state.detail.family_identity_number : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nomor Kartu Keluarga
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.familty_family_card_number !== "" ? this.state.detail.familty_family_card_number : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Status Anak
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_relationship_status_name !== "" ? this.state.detail.family_relationship_status_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Status Perkawinan Anak
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.marital_status_name !== "" ? this.state.detail.marital_status_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <hr />
                                    
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Sedang / Selesai Kuliah
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {
                                                            this.state.detail.family_is_currently_in_college !== "" ? 
                                                                this.state.detail.family_is_currently_in_college == 1 ? 'Ya' : 'Tidak'
                                                            : '-'
                                                        }
                                                    </>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    {
                                        this.state.detail?.family_is_currently_in_college == 1 &&
                                        <>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nama Perguruan Tinggi
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.family_college_name !== "" ? this.state.detail.family_college_name : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Alamat Perguruan Tinggi
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.family_college_place !== "" ? this.state.detail.family_college_place : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Tahun Masuk
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.family_college_year_start !== "" ? this.state.detail.family_college_year_start : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Tahun Lulus
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.family_college_year_graduate !== "" ? this.state.detail.family_college_year_graduate : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            {/* <Row className="mb-3">
                                                <label className="col-md-3">
                                                Dokumen Surat Keterangan Kuliah
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.document_skk ?
                                                            <>{this.state.document_skk.documents_path !== "" ? 
                                                            <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.document_skk.documents_path}>
                                                                <i className="uil-file-download"></i> Download File
                                                            </a>
                                                            : 'Tidak ada dokumen'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row> */}
                                        </>
                                    }

                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama Orang Tua
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.peg_name}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                           Nama Pasangan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_spouse_divorce_number_decree !== "" ? this.state.detail.family_spouse_divorce_number_decree : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <hr />
                                    {/* <Row className="mb-3">
                                        <label className="col-md-3">
                                            Pernikahan Ke
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_spouse_marriage_count !== "" ? this.state.detail.family_spouse_marriage_count : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}
                                    {/* <Row className="mb-3">
                                        <label className="col-md-3">
                                            Tempat Lahir Luar / Dalam Negeri
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_place_of_birth_national !== "" ? this.state.detail.family_place_of_birth_national : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Tempat Lahir
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_place_of_birth_national !== "" ? this.state.detail.family_place_of_birth_national : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Negara Lahir
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_place_of_birth_country_name !== "" ? this.state.detail.family_place_of_birth_country_name : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3"  style={ this.state.isLocal == 0 ? {display:'none'} : {}}>
                                        <label className="col-md-3">
                                            Provinsi Lahir
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_place_of_birth_province_name !== "" ? this.state.detail.family_place_of_birth_province_name : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                <Row className="mb-3"  style={ this.state.isLocal == 0 ? {display:'none'} : {}}>
                                    <label className="col-md-3">
                                        Kota Lahir
                                    </label>
                                    <Col md="9">
                                        {
                                            this.state.detail ?
                                                <>{this.state.detail.family_place_of_birth_city_name !== "" ? this.state.detail.family_place_of_birth_city_name : '-'}</>
                                            : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-3"  style={ this.state.isLocal == 1 ? {display:'none'} : {}}>
                                    <label className="col-md-3">
                                        Kota Lahir
                                    </label>
                                    <Col md="9">
                                        {
                                            this.state.detail ?
                                                <>{this.state.detail.family_place_of_birth_city_text !== "" ? this.state.detail.family_place_of_birth_city_text : '-'}</>
                                            : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                        }
                                    </Col>
                                </Row>
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Tanggal Lahir
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_date_of_birth !== "" ? this.dateParse(this.state.detail.family_date_of_birth) : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    {/* <Row className="mb-3">
                                        <label className="col-md-3">
                                            Dokumen Akta Kelahiran
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.document_akta_kel ?
                                                    <>{this.state.document_akta_kel.documents_path !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.document_akta_kel.documents_path}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Jenis Kelamin
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_gender_name !== "" ? this.state.detail.family_gender_name : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    {/* <Row className="mb-3">
                                        <label className="col-md-3">
                                            Pekerjaan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_profession !== "" ? this.state.detail.family_profession : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Alamat
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_identity_address !== "" ? this.state.detail.family_identity_address : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Kode Pos
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_identity_postal_code !== "" ? this.state.detail.family_identity_postal_code : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nomor Telepon
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_phone_number !== "" ? this.state.detail.family_phone_number : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Jenis Pekerjaan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_spouse_job_type_name !== "" ? this.state.detail.family_spouse_job_type_name : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    { (this.state.detail?.family_spouse_job_type == "1" || this.state.detail?.family_spouse_job_type == "2") ?
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_profession_pns_nip !== "" ? this.state.detail.family_profession_pns_nip : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        : ""
                                    }
                                    { this.state.detail?.family_spouse_job_type == "3" &&
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pekerjaan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_profession !== "" ? this.state.detail.family_profession : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                    }

                                    <hr />

                                    {
                                        this.state.documents?.map((val, i) => {
                                            return (
                                                <Row className="mb-3">
                                                    <label className="col-md-3">
                                                        {this.titleCase(val.family_document_type)}
                                                    </label>
                                                    <Col md="9">
                                                        {
                                                            val.document ?
                                                                <Preview value={val.document} />
                                                            : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                        }
                                                    </Col>
                                                 </Row>
                                            )
                                        })
                                    }

                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="/kepegawaian/home.html?anak" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);